import previewView from "./previewView";
import View from "./view";
class ResultsView extends View
{
  constructor()
  {
    super(
      document.querySelector(".results"),
      "No Recipes Found For Your Query! Please Try Again 🙂",
      "Start by searching for a recipe or an ingredient. Have fun!"
    )
  }
  _generateMarkup()
  {
    return this._data.map(result=>previewView.render(result,false)).join("");
  }
}

export default new ResultsView();